<template>
  <div class="logistics_box">
        <div class="title_box"><span>点击发货，自动产生出库单</span><span class="isCursor" @click="hideBox"><i class="el-icon-close"></i></span></div>
        <div class="logistics_company_box">
          <span>物流公司：</span>
          <input type="text" v-model="logisticsCompany">
        </div>
        <div class="goods_checking_telephone_box">
          <span>查货电话：</span>
          <input type="text" v-model="goodsPhone">
        </div>
        <div class="logistics_order_no_box">
          <span>物流单号：</span>
          <input type="text" v-model="orderNumber">
        </div>
        <el-button @click="confirmShipment">确认发货</el-button>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    data(){
        return{
            logisticsCompany:'',//物流公司
            goodsPhone: '',//查货电话
            orderNumber: '',//物流单号
        }
    },
    props:['orderInfo'],
    computed:{
        ...mapState([
            'userInfo'
        ]),
        supplier_id(){
            if(this.$store.state.supplierInfo){
                return this.$store.state.supplierInfo.id
            }else{
                return 0
            }
        },
    },
    methods:{
        hideBox(){
            this.$emit('hideDeliverGoods')
        },
        confirmShipment(){
            if(this.logisticsCompany == ''){
                this.$message({
                    message:'请填写物流公司',
                    type: 'warning',
                    duration:'1000'
                })
                return
            }
             if(this.orderNumber == ''){
                 this.$message({
                    message:'请填写物流单号',
                    type: 'warning',
                    duration:'1000'
                })
                return
            }
             if(this.goodsPhone == ''){
                 this.$message({
                    message:'请填写查货电话',
                    type: 'warning',
                    duration:'1000'
                })
                return
            }
            this.$post("/py/erp/cloud_order_express",{
                order_id: this.orderInfo.id,
                uid: this.userInfo.id,
                supplier_id: this.supplier_id,
                manual_flag: 1,
                express_company: this.logisticsCompany,
                express_id: this.orderNumber,
                phone: this.goodsPhone
            },res => {
                console.log('发货',res)
                if(res.status == 1){
                    this.$message('发货成功')
                    this.$emit('DeliverGoodsUpData')
                }else{
                    this.$message(res.err_msg+'，发货失败！')
                }
                this.$emit('hideDeliverGoods')
            })
            
        },
    }
}
</script>

<style lang='less' scoped>
    .logistics_box{
        width: 400px;
        height: 260px;
        background-color: #ffffff;
        border-radius: 8px;
        margin: 0 auto;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        .title_box{
            // text-align: left;
            padding: 10px;
            margin-bottom: 10px;
            display: flex;
            justify-content: space-between;
            .isCursor{
                cursor: pointer;
            }
        }
        >div:not(:first-child){
            height: 40px;
            line-height: 40px;
            display: flex;
            justify-content: flex-start;
            margin-bottom: 10px;
            // border: 1px solid red;
            padding: 0 20px;
            span{
                width: 80px;
                display: inline-block;
                // border: 1px solid red;
            }
            input{
                width: 217px;
                height: 40px;
                border-radius: 4px;
                padding-left: 15px;
                margin-left: 10px;
                border: 1px solid #DCDFE6;
                outline: none; // 去除选中状态边框
            }
        
        }
    }
</style>